import cloudinary from 'cloudinary-core';
export default new cloudinary.Cloudinary({ cloud_name: 'bodyf1rst', secure: true });
